import React from "react";
import { useNavigate } from "react-router-dom";
import "../../Css/cardHome.css";
import { useStateValue } from "../../Middleware/context/StateBusinessProvider";
import { useAuth } from "../../Middleware/context/AuthContext";

export default function CardService({
  fornecedor,
  taxa ,
  nameProduto,
  id,
  tipo,
  price ,
  img,
  size,
  description,
  idSupplier,
  destinoVenda,
  category,
  subtype,
  whatsapp,
  tipoArtigo,
}) {
  const navigate = useNavigate();
  const { dispatch } = useStateValue();
  const {user}=useAuth();

  const openDetails = () => {
    if (!tipo || !subtype || !id) return;
    navigate(`/Agendar/${tipo}/${subtype}/${id}`);
  };

  
  const checkout = (user) => {


    if(!user){

         navigate("/UserErro");

    }
 else if(user){  
  
  tipoArtigo="Agenda"
    if (!tipoArtigo) {
    
      return;
    }

    const quantidade = 1;
    const precoFinal = (Number(price) + Number(taxa)) * quantidade;

    dispatch({
      type: "Agenda_Service",
      item: {
        fornecedor,
        taxa,
        nameProduto,
        id,
        tipo,
        price: precoFinal,
        img,
        quantity: quantidade,
        size,
        description,
        idSupplier,
        destinoVenda,
        category,
        status: "Pending",
        tipoArtigo: "Agenda",
      },
    });

    navigate("/Service/Checkout");
  }
  };

  const openWhatsapp = () => {
    const numero = whatsapp ? whatsapp : "244991660829";
    window.open(`https://wa.me/${numero}`, "_blank");
  };

  return (
    <article className="product-card">
      <div className="product-image" onClick={openDetails}>
        <img src={img} alt={nameProduto} />
      </div>

      <div className="product-info">
        <h3>{nameProduto}</h3>
        <p className="supplier">{fornecedor}</p>
        <strong className="price">
          {subtype} {Number(price) + Number(taxa)} Kz
        </strong>
      </div>

      <div className="product-actions">
        <button onClick={()=>{checkout(user)}} className="btn-buy">
          Agendar
        </button>
        <button className="btn-whatsapp" onClick={openWhatsapp}>
          WhatsApp
        </button>
      </div>
    </article>
  );
}